import React from 'react';

import Row from '@amzn/meridian/row';
import TableActionBar from '@amzn/meridian/table-action-bar';
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import ProjectsFilterSection from './ProjectsFilterSection';
import ProjectsFilterTags from './ProjectsFilterTags';

export default function ProjectsActionBar() {
  return (
    <Row widths="fill">
      <TableActionBar alignmentHorizontal="justify">
        <Column spacing="400">
          <Row spacing="200" widths="2-grid">
            <Heading level={3}>Filter Projects</Heading>
          </Row>
          <ProjectsFilterSection />
          <ProjectsFilterTags />
        </Column>
      </TableActionBar>
    </Row>
  );
}
